export default function (el) {
    return el.closest('.calculator__container');
}
